(function() {
    'use strict';

    angular.module('plate')
        .controller('PlateUpdateController', PlateUpdateController);

    PlateUpdateController.$inject = ['$state', 'notificationSrvc', 'plateDataSrvc', 'plateMessagesConst', 'errorNotificationSrvc'];

    function PlateUpdateController($state, notificationSrvc, plateDataSrvc, plateMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            size_x: [],
            size_y: [],
            price: [],
            nonFieldErrors: []
        };
        self.plateData = {
            name: '',
            size_x: undefined,
            size_y: undefined,
            price: undefined
        };

        self.updatePlate = updatePlate;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getPlate();
        }

        function getPlate() {
            return plateDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.plateData = response;

                delete self.plateData.date_modified;
                delete self.plateData.date_added;
                return response;
            });
        }

        function updatePlate() {
            plateDataSrvc.update({
                pk: self.plateData.pk
            }, self.plateData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", plateMessagesConst.update);
                    $state.go('layout.plate.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
